import axios from 'axios';
import { serializeAjaxForm } from '../lib/helper';
import { toArray } from 'lodash';

export default class FormAjax {

  constructor (el) {

    this.form = el;
    this.alert = el.querySelector('.tc-ajax-form-alert');
    this.action = el.action;
    this.method = el.method;
    let csrfTokenTag = document.querySelector('meta[name="csrf-token"]');
    this.csrfToken = csrfTokenTag ? csrfTokenTag.getAttribute('content') : null;
    this.selectFields = toArray(el.querySelectorAll('.tc-ajax-form-field select'));
    this.inputFields = toArray(el.querySelectorAll('.tc-ajax-form-field input'));

    this.registerEvents();
  }

  registerEvents() {

    this.selectFields.forEach(element => {
      element.addEventListener('change', this.handleSubmit.bind(this));
    });

    this.inputFields.forEach(element => {
      element.addEventListener('change', this.handleSubmit.bind(this));
    });

    this.form.addEventListener('submit', this.handleSubmit.bind(this));
  }

  handleSubmit() {

    window.tcLoader.setActive(false);

    axios({
      method: this.method,
      url: this.action,
      data: serializeAjaxForm(this.form),
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': this.csrfToken
      }
    })
    .then(res => {

      this.handleAlert(res.data);
    })
    .catch(error => {
      throw `AjaxForm.js, axios fetch failed: ${error.message} in ${error.fileName}:${error.LineNumber}`;
    });
  }

  handleAlert(data) {

    window.tcLoader.setInactive(false);
    this.alert.querySelector('.inner-wrapper').innerHTML = data.message;

    if (data.success) {

      this.alert.classList.add('alert-success');
      if (this.alert.classList.contains('alert-error')) {

        this.alert.classList.remove('alert-error');
      }
    } else {

      this.alert.classList.add('alert-error');
      if (this.alert.classList.contains('alert-success')) {

        this.alert.classList.remove('alert-success');
      }    }
    this.alert.classList.toggle('hide');
    setTimeout(() => {

      this.alert.classList.toggle('hide');
    }, 3000);
  }
};
